module.exports = __webpack_public_path__ + "img/Group 65.bff5fcd8.jpg";